export default __webpack_public_path__ + "static/media/twitter_bw.b00db139.svg";